/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RewardGrant } from './RewardGrant';
import {
    RewardGrantFromJSON,
    RewardGrantFromJSONTyped,
    RewardGrantToJSON,
    RewardGrantToJSONTyped,
} from './RewardGrant';
import type { TierEntitlement } from './TierEntitlement';
import {
    TierEntitlementFromJSON,
    TierEntitlementFromJSONTyped,
    TierEntitlementToJSON,
    TierEntitlementToJSONTyped,
} from './TierEntitlement';

/**
 * 
 * @export
 * @interface CreateSubscriptionTierBody
 */
export interface CreateSubscriptionTierBody {
    /**
     * 
     * @type {string}
     * @memberof CreateSubscriptionTierBody
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSubscriptionTierBody
     */
    description?: string;
    /**
     * Hex color for the tier's avatar ring and other tier-identity accents.
     * @type {string}
     * @memberof CreateSubscriptionTierBody
     */
    color?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateSubscriptionTierBody
     */
    isActive: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateSubscriptionTierBody
     */
    xpMultiplier: number;
    /**
     * 
     * @type {number}
     * @memberof CreateSubscriptionTierBody
     */
    tierLevel: number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateSubscriptionTierBody
     */
    level4Access: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateSubscriptionTierBody
     */
    image?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CreateSubscriptionTierBody
     */
    upgradeFromPromos?: { [key: string]: string; };
    /**
     * 
     * @type {Array<TierEntitlement>}
     * @memberof CreateSubscriptionTierBody
     */
    entitlements?: Array<TierEntitlement>;
    /**
     * Catalog-item grants (reward-catalog Option B) paid alongside monthlyRewardConfigIds.
     * @type {Array<RewardGrant>}
     * @memberof CreateSubscriptionTierBody
     */
    monthlyRewardGrants?: Array<RewardGrant>;
    /**
     * Catalog-item grants paid alongside onSubscribeRewardConfigIds.
     * @type {Array<RewardGrant>}
     * @memberof CreateSubscriptionTierBody
     */
    onSubscribeRewardGrants?: Array<RewardGrant>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateSubscriptionTierBody
     */
    monthlyRewardConfigIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateSubscriptionTierBody
     */
    onSubscribeRewardConfigIds?: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof CreateSubscriptionTierBody
     */
    upgradeFromRewards?: { [key: string]: Array<string>; };
    /**
     * When true, no Stripe product is created. Used for Industry Pass and manual tier assignment.
     * @type {boolean}
     * @memberof CreateSubscriptionTierBody
     */
    isLegacyTier?: boolean;
}

/**
 * Check if a given object implements the CreateSubscriptionTierBody interface.
 */
export function instanceOfCreateSubscriptionTierBody(value: object): value is CreateSubscriptionTierBody {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    if (!('xpMultiplier' in value) || value['xpMultiplier'] === undefined) return false;
    if (!('tierLevel' in value) || value['tierLevel'] === undefined) return false;
    if (!('level4Access' in value) || value['level4Access'] === undefined) return false;
    return true;
}

export function CreateSubscriptionTierBodyFromJSON(json: any): CreateSubscriptionTierBody {
    return CreateSubscriptionTierBodyFromJSONTyped(json, false);
}

export function CreateSubscriptionTierBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSubscriptionTierBody {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'color': json['color'] == null ? undefined : json['color'],
        'isActive': json['isActive'],
        'xpMultiplier': json['xpMultiplier'],
        'tierLevel': json['tierLevel'],
        'level4Access': json['level4Access'],
        'image': json['image'] == null ? undefined : json['image'],
        'upgradeFromPromos': json['upgradeFromPromos'] == null ? undefined : json['upgradeFromPromos'],
        'entitlements': json['entitlements'] == null ? undefined : ((json['entitlements'] as Array<any>).map(TierEntitlementFromJSON)),
        'monthlyRewardGrants': json['monthlyRewardGrants'] == null ? undefined : ((json['monthlyRewardGrants'] as Array<any>).map(RewardGrantFromJSON)),
        'onSubscribeRewardGrants': json['onSubscribeRewardGrants'] == null ? undefined : ((json['onSubscribeRewardGrants'] as Array<any>).map(RewardGrantFromJSON)),
        'monthlyRewardConfigIds': json['monthlyRewardConfigIds'] == null ? undefined : json['monthlyRewardConfigIds'],
        'onSubscribeRewardConfigIds': json['onSubscribeRewardConfigIds'] == null ? undefined : json['onSubscribeRewardConfigIds'],
        'upgradeFromRewards': json['upgradeFromRewards'] == null ? undefined : json['upgradeFromRewards'],
        'isLegacyTier': json['isLegacyTier'] == null ? undefined : json['isLegacyTier'],
    };
}

export function CreateSubscriptionTierBodyToJSON(json: any): CreateSubscriptionTierBody {
    return CreateSubscriptionTierBodyToJSONTyped(json, false);
}

export function CreateSubscriptionTierBodyToJSONTyped(value?: CreateSubscriptionTierBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'color': value['color'],
        'isActive': value['isActive'],
        'xpMultiplier': value['xpMultiplier'],
        'tierLevel': value['tierLevel'],
        'level4Access': value['level4Access'],
        'image': value['image'],
        'upgradeFromPromos': value['upgradeFromPromos'],
        'entitlements': value['entitlements'] == null ? undefined : ((value['entitlements'] as Array<any>).map(TierEntitlementToJSON)),
        'monthlyRewardGrants': value['monthlyRewardGrants'] == null ? undefined : ((value['monthlyRewardGrants'] as Array<any>).map(RewardGrantToJSON)),
        'onSubscribeRewardGrants': value['onSubscribeRewardGrants'] == null ? undefined : ((value['onSubscribeRewardGrants'] as Array<any>).map(RewardGrantToJSON)),
        'monthlyRewardConfigIds': value['monthlyRewardConfigIds'],
        'onSubscribeRewardConfigIds': value['onSubscribeRewardConfigIds'],
        'upgradeFromRewards': value['upgradeFromRewards'],
        'isLegacyTier': value['isLegacyTier'],
    };
}

